export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/pds.602a0f75.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};